import * as React from 'react';
import { ModalFullscreen, UIHeading2, UIHeading4, UIText1, ArticleParagraph1 } from '@cian/ui-kit';

import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './ProjectModalDesktop.css';
import { IProjectModalBaseProps } from '../../types';
import { ProjectPrice } from '../../../ProjectPrice';
import { ProjectParameters } from '../../../ProjectParameters';

export type IProjectModalDesktopProps = IProjectModalBaseProps;

export const ProjectModalDesktop: React.FC<IProjectModalDesktopProps> = ({
  slider,
  onClose,
  phoneButton,
  name,
  startPrice,
  area,
  floors,
  materials,
  description,
  callbackButton,
}) => {
  return (
    <ModalFullscreen open onClose={onClose}>
      <div className={styles['container']}>
        <div className={styles['header']}>
          <div className={styles['actions']}>
            {phoneButton}
            {callbackButton}
          </div>
          <div className={styles['close-button']} onClick={onClose}>
            <IconActionClose16 display="block" />
          </div>
        </div>
        <div className={styles['body']}>{slider}</div>
        <div className={styles['sidebar']}>
          <div className={styles['name']}>
            <UIHeading2>{name}</UIHeading2>
          </div>
          {startPrice && (
            <UIHeading4>
              <ProjectPrice start={startPrice} />
            </UIHeading4>
          )}
          <div className={styles['parameters']}>
            <UIText1>
              <ProjectParameters area={area} floors={floors} materials={materials} />
            </UIText1>
          </div>
          <div className={styles['description']}>
            <ArticleParagraph1>{description}</ArticleParagraph1>
          </div>
        </div>
      </div>
    </ModalFullscreen>
  );
};
